<template>
	<div class="ziran">
		<div class="zr_pc" v-if="!isPhone">
			<div class="zr_box1">
				<div class="zx1_con flex3">
					<div class="zx1_left" data-aos="fade-up">
						<img src="@/images/gongyi/shan.png" />
					</div>
					<div class="zx1_right" data-aos="fade-up">
						<p>绵竹，中国名酒剑南春的故乡</p>
						<p>和金字塔、玛雅文明一样</p>
						<p>坐落在 “神秘的北纬30度” 上</p>
						<p>地处青藏高原余脉、南连成都平原</p>
						<p>独特的地势环境，优越的自然条件</p>
						<p>赋予了剑南春丰厚的馈赠</p>
						<p>剑南春的酿酒先人们正是在这样的馈赠之中</p>
						<p>领悟出酿酒之道</p>
						<p>也让这片土地陶醉在美酒的浓香韵味之中</p>
					</div>
				</div>
			</div>
			<div class="zr_box2 flex3">
				<div class="zb2_box">
					<div class="zb2_con" data-aos="fade-up">
						<img class="yu_img" src="@/images/gongyi/yuan.png" />
						<div class="yu_text">
							<p>
								地处中国白酒金三角上游，绵竹的季风甘露，携带着青藏高原的纯净，从这片土地上经过。这里的山之浑厚、水之圣洁，都被剑南春的美酒演绎得淋漓尽致。
							</p>
							<br />
							<p>
								正因承载了山水灵犀的原产地之美，剑南春美酒才有如此独特的品质，剑南春也以其独特的魅力，吸引并征服了众多的懂酒之人、爱酒之人。
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="zr_box3">
				<div class="zb3_box1" data-aos="fade-up">
					<img class="wt_img" src="@/images/gongyi/shui.png" />
					<div class="wt_con">
						<p>“水乃酒之魂”是世界公认的酿酒谏言。</p>
						<p>绵竹的水，是孕育剑南春的功臣之一。</p>
						<p>来自高原的冰川雪水经过层层渗透，汇聚于此，</p>
						<p>
							带着地处上游的圣洁，安静从容地和几百万年前冰川时代的古老岩层、沙砾进行着矿物质交换，
						</p>
						<p>形成品质卓越的天然弱碱性矿泉水，</p>
						<p>富含钙、锶、钠、钾等多种天然矿物精华和微量元素，</p>
						<p>为剑南春美酒的酿造注入灵魂。</p>
					</div>
				</div>
				<div class="qp_img">
					<img data-aos-duration="3000" data-aos="fade-up" data-aos-offset="0" src="@/images/gongyi/qipao.png" />
				</div>
			</div>
		</div>
		<div class="zr_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="工艺优胜"></Header2>
			<div class="zr_tab_box flex2">
				<div @click="zrTabChange(index)" v-for="(item, index) in tabList" :key="index" class="zr_tab_item"
					:class="pcrut == index ? 'ph_act1' : ''">
					{{ item }}
				</div>
			</div>
			<!-- 自然美景 -->
			<div class="natural_phone" v-if="pcrut == 0">
				<div class="zr_box1">
					<div class="zx1_con" data-aos="fade-up">
						<div class="zx1_left">
							<img src="@/images/gongyi/shan.png" />
						</div>
						<div class="zx1_right">
							<p>绵竹，中国名酒剑南春的故乡</p>
							<p>和金字塔、玛雅文明一样</p>
							<p>坐落在 “神秘的北纬30度” 上</p>
							<p>地处青藏高原余脉、南连成都平原</p>
							<p>独特的地势环境，优越的自然条件</p>
							<p>赋予了剑南春丰厚的馈赠</p>
							<p>剑南春的酿酒先人们正是在这样的馈赠之中</p>
							<p>领悟出酿酒之道</p>
							<p>也让这片土地</p>
							<p>陶醉在美酒的浓香韵味之中</p>
						</div>
					</div>
				</div>
				<div class="zr_box2">
					<div class="zb2_box">
						<div class="zb2_con" data-aos="fade-up">
							<img class="yu_img" src="@/images/gongyi/yuan.png" />
							<div class="yu_text">
								<p>
									地处中国白酒金三角上游，绵竹的季风甘露，携带着青藏高原的纯净，从这片土地上经过。这里的山之浑厚、水之圣洁，都被剑南春的美酒演绎得淋漓尽致。
								</p>
								<br />
								<p>
									正因承载了山水灵犀的原产地之美，剑南春美酒才有如此独特的品质，剑南春也以其独特的魅力，吸引并征服了众多的懂酒之人、爱酒之人。
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="zr_box3">
					<div class="zb3_box1" data-aos="fade-up">
						<img class="wt_img" src="@/images/gongyi/shui.png" />
						<div class="wt_con">
							<p>“水乃酒之魂”是世界公认的酿酒谏言。</p>
							<p>绵竹的水，是孕育剑南春的功臣之一。</p>
							<p>来自高原的冰川雪水经过层层渗透，汇聚于此，</p>
							<p>
								带着地处上游的圣洁，安静从容地和几百万年前冰川时代的古老岩层、沙砾进行着矿物质交换，
							</p>
							<p>形成品质卓越的天然弱碱性矿泉水，</p>
							<p>
								富含钙、锶、钠、钾等多种天然矿物精华和微量元素，
							</p>
							<p>为剑南春美酒的酿造注入灵魂。</p>
						</div>
					</div>
					<div class="qp_img">
						<img data-aos-duration="3000" data-aos="fade-up" data-aos-offset="0" src="@/images/gongyi/pimg4.png" />
					</div>
				</div>
			</div>
			<!-- 酿造工艺 -->
			<div class="brew_phone" v-if="pcrut == 1">
				<div class="nz_box1">
					<p class="nz_tit" data-aos="fade-up">传统酿造工艺</p>
					<ul class="nzgy_list">
						<li class="nzgy_item" data-aos="fade-up">
							<div class="ztm_d1">
								<img src="@/images/gongyi/gy_img1.png" />
								<p>“天益老号”老窖池</p>
							</div>
							<div class="ztm_d2">
								<p>窖龄越长，其香越幽，其味越正，其品越高，</p>
								<p>绵延了千百年的老窖池——天益老号生生不息，</p>
								<p>其别具一格自成体系的微观生态环境，</p>
								<p>对剑南春基础酒的品质起着关键的作用。</p>
							</div>
						</li>
						<li class="nzgy_item" data-aos="fade-up">
							<div class="ztm_d1">
								<img src="@/images/gongyi/gy_img3.png" />
								<p>精选纯粮酿造</p>
							</div>
							<div class="ztm_d2">
								<p>剑南春甄选优质</p>
								<p>
									高粱、小麦、大米、糯米、玉米等粮食为原料，
								</p>
								<p>传承绵竹千年酿酒技艺的精华，科学配比，</p>
								<p>发挥纯粮独特酿造优势，成就经典浓香滋味。</p>
							</div>
						</li>
					</ul>
				</div>
				<div class="nz_box2">
					<div class="nb2_img" data-aos="fade-up">
						<img src="@/images/gongyi/pimg55.png" />
					</div>
					<div class="nb2_text flex2 wow" data-aos="fade-up">
						<div class="nb2_text_con">
							<p class="tcon_p1">独特的制曲模式</p>
							<p class="tcon_p2">
								剑南春使用的是依靠天然微生物接种制作的大曲药，在用曲之道上，剑南春融汇众长，反复锤炼，其酿制之酒，得曲之神韵，既保证了产量，又保证了酿制过程中各种复杂香味物质的生化合成。
							</p>
						</div>
					</div>
				</div>
				<div class="nz_box1">
					<ul class="nzgy_list">
						<li class="nzgy_item" data-aos="fade-up">
							<div class="ztm_d1">
								<img src="@/images/gongyi/gy_img1.png" />
								<p>独创的经典工艺</p>
							</div>
							<div class="ztm_d2">
								<p>
									剑南春的传统酿造工艺入选了国家非物质文化遗产，
								</p>
								<p>在传承古老酿艺的同时，</p>
								<p>
									剑南春独创了中国传统浓香型白酒生产的经典特色工艺——
								</p>
								<p class="font600">
									“一低、二长、三控、四适当、五精作、六结合”。
								</p>
							</div>
						</li>
						<li class="nzgy_item" data-aos="fade-up">
							<div class="ztm_d1">
								<img src="@/images/gongyi/gy_img3.png" />
								<p>陶坛贮存老熟</p>
							</div>
							<div class="ztm_d2">
								<p>贮藏是白酒传统工艺中一道重要的工序，</p>
								<p>剑南春酒采用陶坛贮存老熟，</p>
								<p>经年储存的白酒在陶坛中成熟蜕变，</p>
								<p>
									滋味随贮存时间的增加更加突出，滋味更加悠美、绵柔。
								</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<!-- 传承发展 -->
			<div class="development" v-if="pcrut == 2">
				<div class="ht_box1">
					<div class="ht_box1_con">
						<p class="mj_tit" data-aos="fade-up">
							<img src="@/images/gongyi/pimg7.png" />
						</p>
						<div class="build" data-aos="fade-up">
							<img class="bd_img" src="@/images/gongyi/pimg6.png" />
							<div class="bd_list">
								<span class="bd_item1">1997年通过四川省级技术中心认定</span>
								<span class="bd_item1">2002年公司设立博士后科研工作站</span>
								<span class="bd_item2">2008年通过国家五部委认定为“国家认定企业技术中心”</span>
								<span class="bd_item1">2013年设立德阳院士专家工作站</span>
								<span class="bd_item1">2014年设立了四川省品酒技能大师工作室</span>
								<span class="bd_item2">2017年设立了国家级品酒技能大师工作室</span>
							</div>
						</div>
						<ul class="tj_list" data-aos="fade-up">
							<li class="tj_item flex2">
								<div class="tj_item_left flex3">
									<span>30</span>
									<div>
										<p>十</p>
										<p>年</p>
									</div>
								</div>
								<div class="tj_item_right">
									<p>
										30多年来，剑南春积极推进企业科研工作向高层次、
										前瞻性发展。
									</p>
								</div>
							</li>
							<li class="tj_item flex2">
								<div class="tj_item_left flex3">
									<span>4</span>
									<div>
										<p>十</p>
										<p>亿</p>
									</div>
								</div>
								<div class="tj_item_right">
									<p>
										集团不断加大对科研力量投入，科研装备投入已达4亿元。，
									</p>
								</div>
							</li>
							<li class="tj_item flex2">
								<div class="tj_item_left flex3">
									<span>30</span>
									<div>
										<p>十</p>
										<p>项</p>
									</div>
								</div>
								<div class="tj_item_right">
									<p>
										重大科技进步成果奖，对传统酿造
										酒业的科技创新做出了突出贡献。
									</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="ht_box2">
					<div class="ht_box2_con">
						<p class="jy_img" data-aos="fade-up">
							<img src="@/images/gongyi/jytd.png" />
						</p>
						<p class="hb_tit" data-aos="fade-up">
							人才是企业之本，高素质、专业化的科研人员团队是剑南春品质的坚实基础。
						</p>
						<ul class="expert_list" data-aos="fade-up">
							<li class="expert_item" data-aos="fade-up">
								<div class="tt_con">
									<div class="tt_img">
										<img src="@/images/gongyi/pimg8.png" />
									</div>
									<div class="tj_item flex2">
										<div class="tj_item_left flex3">
											<span>7</span>
											<div>
												<p style="color: transparent">
													十
												</p>
												<p>位</p>
											</div>
										</div>
										<div class="tj_item_right">
											<p>
												享受国务院政府特殊津贴在职专家
											</p>
										</div>
									</div>
								</div>
							</li>
							<li class="expert_item" data-aos="fade-up">
								<div class="tt_con">
									<div class="tt_img">
										<img src="@/images/gongyi/pimg9.png" />
									</div>
									<div class="tj_item flex2">
										<div class="tj_item_left flex3">
											<span>40</span>
											<div>
												<p>十</p>
												<p>位</p>
											</div>
										</div>
										<div class="tj_item_right">
											<p>
												包括中国酿酒大师、国家级专家委员会专家、中国首席评酒师和中国白酒大师、突出贡献优秀专家等在内的白酒专家教授。
											</p>
										</div>
									</div>
								</div>
							</li>
							<li class="expert_item" data-aos="fade-up">
								<div class="tt_con">
									<div class="tt_img">
										<img src="@/images/gongyi/pimg10.png" />
									</div>
									<div class="tj_item flex2">
										<div class="tj_item_left flex3">
											<span>400</span>
											<div>
												<p>十</p>
												<p>位</p>
											</div>
										</div>
										<div class="tj_item_right">
											<p>
												高级智能型和高级技能型人才，中级科技人员和中级技能人才占本岗位人员的60%以上。
											</p>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="ht_box3">
					<div class="ht_box3_con">
						<img data-aos="fade-up" class="ht3_tit" src="@/images/gongyi/cx.png" />
						<div class="ht3_p" data-aos="fade-up">
							<p>
								剑南春作为中国白酒行业科技发展的引领者，科研技术水平继续保持国内外行业中的领先地位，
							</p>
							<p>
								取得国家、省、市各级科技奖励30多项，有效专利350件，
							</p>
							<p>
								这些科技成果为中国白酒业技术创新和核心技术的形成提供了有力保障。
							</p>
						</div>
						<ul class="cx_list">
							<li class="cx_item" data-aos="fade-up">
								<img src="@/images/gongyi/pimg12.png" />
								<div class="ctm_text">
									<p class="ctm_text_p1">
										挥发系数鉴别年份酒新方法
									</p>
									<p class="ctm_text_p2">
										剑南春的科研团队在徐占成总工程师的带领下，发明了“挥发系数鉴别年份酒的方法”，这项重大科研成果不仅填补了国内外年份酒鉴别方法的空白，而且成功的破解了困扰酒类行业多年的世界性技术难题，在推进中国白酒的国际化进程中做出重大贡献。
									</p>
								</div>
							</li>
							<li class="cx_item" data-aos="fade-up">
								<img src="@/images/gongyi/pimg13.png" />
								<div class="ctm_text">
									<p class="ctm_text_p1">酒体风味设计学</p>
									<p class="ctm_text_p2">
										剑南春在白酒风味特征形成规律及生成机理研究的基础上，开创性地建立了酒体风味设计学的科学体系。酒体风味设计是对我国白酒行业技术创新的理论性总结，对于提升全行业总体科学技术水平具有重要意义和深远影响，是中国白酒工业工艺技术继承、创新和发展的里程碑。
									</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="ht_box4">
					<div class="ht_box4_con">
						<div class="qu_left2">
							<div class="ft_text" data-aos="fade-up">
								<p class="txt_p1">曲药天书</p>
								<p class="txt_p2">
									剑南春应用现代分子生物学技术，破译了浓香型白酒主要呈香呈味物质的生成与曲药微生物群系的潜在关系，选育出多株代谢酿酒生物酶和健康因子的特殊功能微生物，在保持酒体典型风味特征不变的基础上，大幅提高了酒体中关键风味物质和健康因子含量，确保了产品安全性和优质品率。
								</p>
								<br />
								<p class="txt_p2">
									在继承传统制曲模式的同时，剑南春搭建了曲药质量等级鉴定体系制，创立了一套大曲药工艺技术质量标准，从根本上改变了传统制曲操作“靠经验、凭感觉”的不确定性，这是传统中温大曲生产工艺技术的重大升华，为智能化制曲生产提供了有力技术支撑。
								</p>
							</div>
							<div class="ft_img">
								<img src="@/images/gongyi/pimg14.png" />
							</div>
						</div>
						<div class="qu_left2 touming" data-aos="fade-up">
							<p class="txt_p1">老窖新生</p>
							<p class="txt_p2">
								剑南春通过对天益老号窖池中的功能菌株进行定性研究，发现并命名浓香型酒主体香味物质的功能菌株——“耳蜗形梭菌”，这为剑南春独特风味特征的形成奠定了基础。该成果荣获中国食品工业协会科学技术进步一等奖。
							</p>
							<p class="txt_p2">
								在剑南春传统酿造技艺发展的过程中，利用现代生物技术分离选育老窖关键功能微生物菌群，使传统技艺与科技创新有机融合，形成其独特传承体系，确保了剑南春酒在不断发展过程中保持了高贵典雅的时尚品质。
							</p>
							<br />
							<div class="ft_img">
								<img src="@/images/gongyi/pimg15.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="ht_box5" data-aos="fade-up">
					<div class="ht_box5_con">
						<p class="txt_p1">智能评价</p>
						<p class="txt_p3">
							剑南春研究团队发明了“秒持值衡定评酒法”并研究了“剑南春名优白酒质量评价体系”，打破了传统的感官评酒方式，使“只可意会，不可言传”的传统感官尝评方法能够被数据化、标准化的科学方法所代替，将评酒专家们的评酒智能、理化数据转化成一个高智能化的评价体系，达到了国内白酒行业领先水平，这是酿酒行业的重大技术创新。
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
			pcrut: 0,
			tabList: ["自然美境", "酿造工艺", "传承发展"],
		};
	},
	methods: {
		zrTabChange(index) {
			this.pcrut = index;
			window.scrollTo({
				top: 0,
				// behavior: "smooth", // 可选平滑滚动
			});
		},
	},
};
</script>

<style lang="scss">
.ph_act1 {
	color: #c00 !important;
	&::after {
		display: block !important;
	}
}
.ziran {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.zr_pc {
		margin-top: 76px;
		padding-bottom: 70px;
		min-width: 950px;
		.zr_box1 {
			box-sizing: border-box;
			background-image: url("../../images/gongyi/gbimg1.png");
			background-repeat: no-repeat;
			background-position: bottom;
			background-size: 100% 906px;
			padding: 80px 20px 465px;
			margin-bottom: 10px;
			.zx1_con {
				max-width: 1110px;
				margin: 0 auto;
				.zx1_left {
				}
				.zx1_right {
					box-sizing: border-box;
					color: #454953;
					font-size: 18px;
					overflow: hidden;
					padding-left: 50px;
					line-height: 1.8;
					p {
						text-align: left;
					}
				}
			}
		}
		.zr_box2 {
			background-image: url("../../images/gongyi/pubu.png");
			background-repeat: no-repeat;
			background-size: cover;
			background-position: bottom;
			margin-bottom: 10px;
			justify-content: flex-end;
			.zb2_box {
				width: 670px;
				height: 1000px;
				background-color: hsla(0, 0%, 100%, 0.8);
				.zb2_con {
					position: relative;
					top: 30%;
					max-width: 450px;
					margin: 0 auto;
					.yu_img {
						margin: 0 auto;
						margin-bottom: 66px;
					}
					.yu_text {
						color: #474747;
						font-size: 18px;
						line-height: 1.8;
						p {
							text-align: left;
						}
					}
				}
			}
		}
		.zr_box3 {
			background-image: url("../../images/gongyi/ocean.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-position: bottom;
			padding: 188px 20px 196px 0;
			position: relative;
			width: 100%;
			box-sizing: border-box;
			overflow: hidden;
			.zb3_box1 {
				.wt_img {
					max-width: 100%;
					margin-bottom: 36px;
				}
				.wt_con {
					p {
						text-align: center;
						font-size: 18px;
						line-height: 1.8;
						color: #fff;
					}
				}
			}
			.qp_img {
				position: absolute;
				width: 100%;
				text-align: center;
				bottom: 0;
				left: 0;
				z-index: 0;
				padding: 0 50px;
                box-sizing: border-box;
				img {
                    max-width: 100%;
                    vertical-align: middle;
                    margin: 0 auto;
				}
			}
		}
	}
	.zr_phone {
		padding-top: 2.4rem;
		padding-bottom: 2.2rem;
		.natural_phone {
			.zr_box1 {
				background-repeat: no-repeat;
				background-size: cover;
				background-position: bottom;
				background-image: url("../../images/gongyi/pimg1.png");
				padding: 0.93rem 1.04rem 4.16rem;
				.zx1_con {
					.zx1_left {
						margin-bottom: 0.72rem;
						img {
							max-height: 1.52rem;
						}
					}
					.zx1_right {
						color: #333;
						font-size: 14px;
						line-height: 1.8;
						p {
							text-align: left;
						}
					}
				}
			}
			.zr_box2 {
				background-image: url("../../images/gongyi/pimg2.png");
				padding: 1.15rem 1.07rem;
				background-repeat: no-repeat;
				background-size: cover;
				background-position: bottom;
				.zb2_box {
					background-color: hsla(0, 0%, 100%, 0.7);
					padding: 0.72rem 0.56rem 0.53rem;
					.zb2_con {
						.yu_img {
							margin-bottom: 0.72rem;
							max-height: 1.52rem;
						}
						.yu_text {
							color: #333;
							font-size: 14px;
							line-height: 1.8;
							p {
								text-align: left;
							}
						}
					}
				}
			}
			.zr_box3 {
				background-image: url("../../images/gongyi/pimg3.png");
				background-repeat: no-repeat;
				background-size: cover;
				background-position: bottom;
				padding: 2.45rem 0.85rem 2.67rem;
				position: relative;
				.zb3_box1 {
					.wt_img {
						max-height: 1.52rem;
						margin-bottom: 0.72rem;
					}
					.wt_con {
						color: #fff;
						z-index: 9;
						p {
							text-align: center;
							line-height: 1.8;
							color: #fff;
							font-size: 14px;
						}
					}
				}
				.qp_img {
					position: absolute;
					width: 100%;
					text-align: center;
					bottom: 0;
					left: 0;
					z-index: 0;
					img {
						width: 100%;
					}
				}
			}
		}
		.brew_phone {
			background-image: url("../../images/bgimg3.png");
			.nz_box1 {
				padding: 0.61rem 0.53rem 0.53rem;
				.nz_tit {
					color: #c0494b;
					font-size: 19px;
					font-weight: 700;
					margin-bottom: 0.43rem;
					text-align: center;
				}
				.nzgy_list {
					.nzgy_item {
						margin-bottom: 0.72rem;
						.ztm_d1 {
							position: relative;
							overflow: hidden;
							img {
								transition: transform 0.5s ease;
								width: 100%;
								&:hover {
									transform: scale(1.1);
								}
							}
							p {
								position: absolute;
								background-image: url("../../images/gongyi/gy_img2.png");
								background-repeat: no-repeat;
								background-position: 50%;
								background-size: 5.36rem auto;
								line-height: 1.13rem;
								width: 100%;
								left: 0;
								bottom: 0.4rem;
								text-align: center;
								color: #fff;
								font-size: 19px;
							}
						}
						.ztm_d2 {
							color: #333;
							font-size: 14px;
							line-height: 1.8;
							padding-top: 0.37rem;
							text-align: left;
						}
					}
				}
			}
			.nz_box2 {
				position: relative;
				.nb2_img {
					overflow: hidden;
					animation-duration: 1.5s;
					img {
						width: 100%;
						display: block;
						transition: transform 0.5s ease;
					}
				}
				.nb2_text {
					position: absolute;
					width: 90%;
					left: 5%;
					top: 22%;
					z-index: 9;
					background-color: rgba(87, 57, 36, 0.4);
					padding: 0.8rem 0.3rem;
					min-height: 6.85rem;
					box-sizing: border-box;
					.nb2_text_con {
						max-width: 310px;
						.tcon_p1 {
							background-image: url("../../images/gongyi/gy_img6.png");
							color: #fff;
							font-size: 19px;
							font-weight: 700;
							height: 1.17rem;
							line-height: 1.17rem;
							background-repeat: no-repeat;
							background-position: 50%;
							background-size: 5.36rem auto;
							text-align: center;
							margin-bottom: 0.6rem;
						}
						.tcon_p2 {
							color: #fff;
							font-size: 14px;
							line-height: 1.7;
							text-align: left;
						}
					}
				}
			}
		}
		.development {
			background-image: url("../../images/bgimg3.png");
			.ht_box1 {
				padding: 0.61rem 0.53rem 0;
				.ht_box1_con {
					.mj_tit {
						margin-bottom: 0.27rem;
						img {
							height: 0.49rem;
						}
					}
					.build {
						margin-bottom: 34px;
						position: relative;
						.bd_img {
							width: 100%;
						}
						.bd_list {
							margin-top: 0.53rem;
							span {
								display: block;
								color: #666;
								font-size: 0.37rem;
								padding-left: 0.59rem;
								background-image: url("../../images/gongyi/point.png");
								background-repeat: no-repeat;
								background-position: 0;
								background-size: 0.16rem auto;
								margin-bottom: 0.37rem;
								text-align: left;
							}
						}
					}
					.tj_list {
						padding: 0.45rem 0.53rem;
						background-color: #fff;
						margin: 0 -0.53rem;
						.tj_item {
							margin-top: 0.56rem;
							&:nth-child(1) {
								margin-top: 0;
							}
							.tj_item_left {
								display: flex;
								align-items: center;
								padding-left: 0.32rem;
								flex-shrink: 0;
								font-weight: 700;
								width: 2.85rem;
								span {
									color: #c84143;
									font-size: 1.12rem;
									width: 1.2rem;
									padding-right: 5px;
									text-align: center;
									letter-spacing: -3px;
								}
								div {
									color: #c0494b;
									font-size: 16px;
									font-weight: 700;
									flex-direction: column;
									display: flex;
									padding-left: 0.13rem;
								}
							}
							.tj_item_right {
								color: #333;
								font-size: 0.37rem;
								line-height: 1.8;
								padding-left: 5px;
								flex: 1;
								p {
									text-align: left;
								}
							}
						}
					}
				}
			}
			.ht_box2 {
				background-image: url("../../images/gongyi/pimg11.png");
				background-repeat: no-repeat;
				background-size: cover;
				padding: 0.57rem;
				background-position: 50%;
				.ht_box2_con {
					.jy_img {
						margin-bottom: 0.27rem;
						img {
							height: 0.49rem;
						}
					}
					.hb_tit {
						text-align: center;
						color: #666;
						font-size: 0.32rem;
						line-height: 1.8;
						margin-bottom: 0.27rem;
					}
					.expert_list {
						.expert_item {
							margin-bottom: 0.59rem;
							.tt_con {
								.tt_img {
									transition: all 0.5s ease;
									overflow: hidden;
									img {
										width: 100%;
										display: block;
									}
								}
								.tj_item {
									background-color: #fff;
									display: flex;
									align-items: center;
									padding: 0.37rem 0.3rem;
									.tj_item_left {
										display: flex;
										align-items: center;
										flex-shrink: 0;
										font-weight: 700;
										width: 2.24rem;
										justify-content: center;
										span {
											font-weight: 700;
											color: #c0494b;
											font-size: 0.96rem;
											margin-right: 0.1rem;
										}
										div {
											font-weight: 700;
											color: #c0494b;
											font-size: 16px;
											line-height: 1;
										}
									}
									.tj_item_right {
										color: #333;
										font-size: 0.29rem;
										line-height: 1.7;
										flex: 1;
										padding-left: 0.16rem;
										p {
											text-align: left;
										}
									}
								}
							}
						}
					}
				}
			}
			.ht_box3 {
				padding: 0.6rem 0.53rem 0.13rem;
				.ht_box3_con {
					max-width: 1710px;
					margin: 0 auto;
					.ht3_tit {
						margin-bottom: 0.27rem;
						height: 0.49rem;
					}
					.ht3_p {
						text-align: center;
						color: #666;
						font-size: 0.32rem;
						line-height: 1.8;
						margin-bottom: 0.27rem;
					}
					.cx_list {
						.cx_item {
							margin-bottom: 0.6rem;
							position: relative;
							img {
								width: 100%;
							}
							.ctm_text {
								background-color: #fff;
								padding: 0.32rem;
								.ctm_text_p1 {
									color: #c0494b;
									font-size: 0.37rem;
									margin-bottom: 0.27rem;
									font-weight: 700;
								}
								.ctm_text_p2 {
									color: #333;
									font-size: 0.29rem;
									line-height: 1.7;
									text-align: left;
								}
							}
						}
					}
				}
			}
			.ht_box4 {
				.ht_box4_con {
					.qu_left2 {
						background-color: #fff;
						padding: 0.72rem 0.53rem 0.64rem;
						.txt_p1 {
							text-align: center;
							color: #c0494b;
							font-size: 0.4rem;
							margin-bottom: 0.27rem;
							font-weight: 700;
						}
						.txt_p2 {
							color: #666;
							font-size: 14px;
							line-height: 1.8;
							margin-bottom: 0.33rem;
						}
						.ft_img {
							box-shadow: 0 6px 6px 0 rgba(43, 0, 0, 0.2);
							img {
								width: 100%;
								display: block;
							}
						}
					}
				}
			}
			.ht_box5 {
				background-color: transparent;
				background-image: url("../../images/gongyi/pimg16.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-bottom: 0.5rem;
				.ht_box5_con {
					padding: 0.72rem 0.53rem 0.64rem;
					.txt_p1 {
						text-align: center;
						color: #c0494b;
						font-size: 0.37rem;
						margin-bottom: 0.27rem;
						font-weight: 700;
					}
					.txt_p3 {
						color: #666;
						font-size: 14px;
						line-height: 1.8;
						margin-bottom: 0.33rem;
					}
				}
			}
		}
	}
}
</style>